import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router';
import { getProjectAudits } from '../../api/audits';
import { ProjectAuditUI } from './ProjectAuditUI';

const PAGE_SIZE = 50;

export function ProjectAuditView() {
  const { projectId } = useParams();
  const [page, setPage] = useState(1);
  const parsedProjectId = Number(projectId);
  const isValidProjectId = Number.isInteger(parsedProjectId) && parsedProjectId > 0;

  const auditQuery = useQuery({
    queryKey: ['sherpa', 'project-audits', parsedProjectId, page],
    queryFn: () =>
      getProjectAudits({
        page,
        resource_type: 'project',
        resource_id: parsedProjectId,
      }),
    enabled: isValidProjectId,
  });

  return (
    <ProjectAuditUI
      audits={auditQuery.data?.data ?? []}
      page={page}
      isLoading={auditQuery.isLoading}
      isError={auditQuery.isError || !isValidProjectId}
      onRetry={() => void auditQuery.refetch()}
      onPrevious={() => setPage((currentPage) => Math.max(1, currentPage - 1))}
      onNext={() => setPage((currentPage) => currentPage + 1)}
      pageSize={PAGE_SIZE}
    />
  );
}
